import React, { useState } from "react";

import { $Profile } from "./services";

import Answer from "./Components/Answer";
import EmailForm from "./Components/EmailForm";
import QuestionsForm from "./Components/QuestionsForm";

import "./app.sass";
import "./footer.sass";

import etcBrand from "./assets/images/etc-brand.png";
import vLabBrand from "./assets/images/vlab-brand.png";

import gifOne from "./assets/images/1.gif";
import gifTwo from "./assets/images/2.gif";

import questions from "./Components/QuestionsForm/questions";

function App() {
  const [state, setState] = useState({
    loading: false,
    total: 0,
    questions: [],
    fullTotal: questions
      .flatMap(each => each.questions)
      .reduce((acc, each) => acc + each.value, 0),
    emailForm: { title: "Me conta uma coisa?", active: false },
  });

  function onModalClose() {
    return setState(prev => ({
      ...prev,
      emailForm: { ...prev.emailForm, total: 0, active: false },
    }));
  }

  function onEmailSubmitHandler(email) {
    setState(prev => ({
      ...prev,
      loading: true,
      total: 0,
      emailForm: { ...prev.emailForm, active: false },
    }));

    window.scrollTo({
      top: 100,
      behavior: "smooth",
    });
    $Profile.create({ email, questions: state.questions }).finally(() => {
      setState(prev => ({
        ...prev,
        loading: false,
        total: prev.emailForm.total,
      }));
    });
  }

  function onSubmitHandler(total, questions) {
    setState(prev => ({
      ...prev,
      questions,
      loading: true,
      emailForm: { ...prev.emailForm, total, active: true },
    }));
  }

  return (
    <div className="App">
      <div className="wrapper">
        <div className="content">
          <p className="brand">Tenha um</p>
          <h2 className="subtitle">Perfil Vendedor</h2>
          <h1 className="title">Google Meu Negócio</h1>
          <p className="desc">
            Você está explorando o máximo do Google Meu Negócio? Responta o
            questionário e avalie como está seu Perfil. Ao final vamos sugerir
            como ter um Perfil Vendedor!
          </p>
          <div className="result">
            <div className={`gif-wrapper ${state.loading ? "--active" : ""}`}>
              <img
                className="gif --one"
                src={gifOne}
                alt="Estamos calculando seu resultado"
                title="Calculando seu resultado"
              />
              <img
                className="gif --two"
                src={gifTwo}
                alt="Estamos calculando seu resultado"
                title="Calculando seu resultado"
              />
            </div>
          </div>
          <Answer {...state} />
        </div>
        <QuestionsForm onSubmit={onSubmitHandler} />
      </div>
      <footer className="footer">
        <img
          src={etcBrand}
          alt="Entrecliques"
          title="Entrecliques"
          className="brand --etc"
        />
        <span className="detail">+</span>
        <img
          src={vLabBrand}
          alt="VarejoLab"
          title="VarejoLab"
          className="brand vlab"
        />
      </footer>
      <EmailForm
        {...state.emailForm}
        onClose={onModalClose}
        onSubmit={onEmailSubmitHandler}
      />
    </div>
  );
}

export default App;
